var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bhiupl584a",
    d: "M17.5 35C7.835 35 0 27.165 0 17.5S7.835 0 17.5 0 35 7.835 35 17.5 27.165 35 17.5 35zm0-1C26.613 34 34 26.613 34 17.5S26.613 1 17.5 1 1 8.387 1 17.5 8.387 34 17.5 34zm6.273-15.643c1.64-1.68 1.636-4.411-.009-6.096-1.637-1.678-4.283-1.682-5.915-.01l-.357.366-.358-.364c-1.638-1.67-4.278-1.67-5.907-.001-1.64 1.679-1.636 4.41.009 6.096l6.273 6.436 6.264-6.427z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -104) translate(40 104)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gnt4dte57b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bhiupl584a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#bhiupl584a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.509 26.216l-6.989-7.17c-2.023-2.073-2.027-5.425-.009-7.493 1.907-1.953 4.937-2.064 6.98-.333 2.037-1.734 5.075-1.619 6.989.342 2.023 2.073 2.027 5.425.009 7.493l-6.98 7.16z",
    mask: "url(#gnt4dte57b)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCircle);
export default __webpack_public_path__ + "static/media/heart-circle.216811a2875f9979f5ca4657486d13fe.svg";
export { ForwardRef as ReactComponent };